var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingApprovalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3215 13.5198C13.3385 13.5198 14.8475 13.5198 15.7843 12.5821C16.7212 11.6444 16.722 10.1363 16.722 7.11927C16.722 4.10223 16.722 2.5933 15.7843 1.65643C14.8467 0.71955 13.3385 0.71875 10.3215 0.71875H7.12122C4.10418 0.71875 2.59526 0.71875 1.65838 1.65643C0.721503 2.5941 0.720703 4.10223 0.720703 7.11927C0.720703 10.1363 0.720703 11.6452 1.65838 12.5821C2.18082 13.1054 2.88088 13.3366 3.92096 13.4382",
    stroke: "#4C6484",
    strokeWidth: 1.44012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32227 7.12357L8.12241 8.7237L11.1227 5.52344",
    stroke: "#4C6484",
    strokeWidth: 1.44012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3226 13.5282C9.33369 13.5282 8.244 13.9283 7.24952 14.4443C5.65099 15.274 4.85172 15.6892 4.45809 15.4244C4.06446 15.1596 4.13887 14.3403 4.28848 12.701L4.32208 12.3281",
    stroke: "#4C6484",
    strokeWidth: 1.44012,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApprovalIcon);
export default __webpack_public_path__ + "static/media/pending-approval-icon.61ff55fc4648e42969dd3f3751c014ad.svg";
export { ForwardRef as ReactComponent };